import { createContext } from '@bowtie-web/common';
import { FC, useMemo } from 'react';
import useQuotationQs, { QuotationQs } from '../hooks/useQuotationQs';

export type AttributeAndQsContextProps = QuotationQs & {
  size?: 'small' | 'large' | 'responsive';
};

export const [useAttributeAndQsContext, AttributeAndQsContext] =
  createContext<AttributeAndQsContextProps>();

export const AttributeAndQsContextProvider: FC<{
  attributeValues?: Partial<AttributeAndQsContextProps>;
}> = ({ children, attributeValues }) => {
  const qsParams = useQuotationQs();

  /*
  Overriding order:
  parent querystring > iframe querystring > iframe hash > web component attribute data (only available in wc) > local storage > form default params
 */
  const value = useMemo(
    () => ({
      ...attributeValues,
      ...qsParams,
    }),
    [attributeValues, qsParams],
  );

  return (
    <AttributeAndQsContext.Provider value={value}>
      {children}
    </AttributeAndQsContext.Provider>
  );
};

export const AttributeAndQsContextConsumer = AttributeAndQsContext.Consumer;
